<ng2-pdfjs-viewer
  #pdfViewer
  viewerId="pdfViewer"
  [class.print_view]="isPrint"
  [class.hidden]="isCordovaIos"
  [pdfSrc]="pdfBlobUrl()"
  [pageMode]="store.pubInfo?.isPackagePDF ? 'none' : 'bookmarks'"
  [showDownload]="showDownload"
  [showOpenFile]="false"
  [showSpinner]="true"
  [urlValidation]="false"
  (onDocumentLoad)="onDocumentLoad()" />

@if (!extraDocId) {
  <o-notes-button class="notes-button" />
}
